import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import constants from '../../constants';
import Text from '../svg/Text';
import Video from '../svg/Video';
import ImageText from '../svg/ImageText';
import Image from '../svg/Image';
import LinkIcon from '../svg/Link';
import _actions from '../../actions';

class CustomContentTypeSelector extends Component {
    render() {
        return (
            <div className={`content-types-section ${this.props.add ? 'adding' : ''}`}>
                {this.props.flags.results?.customContentBanner
                            && (
                                <div
                                    data-qa="content-type-selector-banner"
                                    className={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Banner' ? 'active' : ''}
                                    onClick={() => { if (constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name !== 'Banner') { this.props.addContentType(constants.ContentType.find((c) => { return c.Name === 'Banner'; })?.Id); } }}
                                >
                                    <span className="type-icon fill">
                                        <Image active={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Banner'} />
                                    </span>
                                    <span className="type-label">
                                        Banner Image
                                    </span>
                                </div>
                            )}
                {this.props.flags.results?.customContentTextWithImage
                                && (
                                    <div
                                        data-qa="content-type-selector-imgtext"
                                        onClick={() => { if (constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name !== 'Image & Text') { this.props.addContentType(constants.ContentType.find((c) => { return c.Name === 'Image & Text'; })?.Id); } }}
                                        className={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Image & Text' ? 'active' : ''}
                                    >
                                        <span className="type-icon">
                                            <ImageText active={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Image & Text'} />
                                        </span>
                                        <span className="type-label">
                                            Image & Text
                                        </span>
                                    </div>
                                )}
                {this.props.flags.results?.customContentText
                                && (
                                    <div
                                        data-qa="content-type-selector-text"
                                        onClick={() => { if (constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name !== 'Text') { this.props.addContentType(constants.ContentType.find((c) => { return c.Name === 'Text'; })?.Id); } }}
                                        className={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Text' ? 'active' : ''}
                                    >

                                        <span className="type-icon">
                                            <Text active={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Text'} />
                                        </span>
                                        <span className="type-label">
                                            Text
                                        </span>
                                    </div>
                                )}
                {this.props.flags.results?.customContentLink
                                && (
                                    <div
                                        data-qa="content-type-selector-link"
                                        onClick={() => { if (constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name !== 'LinkButton') { this.props.addContentType(constants.ContentType.find((c) => { return c.Name === 'LinkButton'; })?.Id); } }}
                                        className={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'LinkButton' ? 'active' : ''}
                                    >

                                        <span className="type-icon">
                                            <LinkIcon active={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'LinkButton'} />
                                        </span>

                                        <span className="type-label">Link/Button</span>
                                    </div>
                                )}
                {this.props.flags.results?.customContentVideo
                                && (

                                    <div
                                        data-qa="content-type-selector-video"
                                        onClick={() => { if (constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name !== 'Video') { this.props.addContentType(constants.ContentType.find((c) => { return c.Name === 'Video'; })?.Id); } }}
                                        className={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Video' ? 'active' : ''}
                                    >

                                        <span className="type-icon fill">
                                            <Video color={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Video' ? '#176BFB' : null} active={constants.ContentType.find((c) => { return c.Id === this.props.active; })?.Name === 'Video'} />
                                        </span>
                                        <span className="type-label">Video</span>
                                    </div>
                                )}

            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomContentTypeSelector);
